export const borderRadiusBase = 4;
/**
 * The calculated value of each value is determined by 'base * $TOKEN' https://mui.com/system/borders/#border-radius
 */
export const borderRadius = {
    none: 0,
    sm: 1,
    md: 2,
    round: 50,
} as const;

export function calculateBorderRadius(borderRadius: number) {
    return borderRadius * borderRadiusBase;
}
